import React from 'react';
import '../styles/Legal.css';

const LegalRefund = () => {
  return (
    <div className="legal-page">
      <h1>Refund Policy</h1>

      <h2>Trials</h2>
      <p>If offered, you won’t be charged until the trial ends. Cancel before the trial ends to avoid charges.</p>

      <h2>Subscriptions</h2>
      <p>Charges are nonrefundable, including partial periods, unless required by law. Access continues through the current billing cycle after cancellation.</p>

      <h2>Billing Errors</h2>
      <p>If you believe there’s a billing error, contact us at cali.salcedo@theboxesports.com within 14 days; we’ll investigate and correct if appropriate.</p>

      <h2>Exceptional Cases</h2>
      <p>We may grant discretionary refunds for extenuating circumstances, but they’re not guaranteed.</p>

      <h2>Startup/Partnership Note</h2>
      <p>As a growing startup, we’re committed to working with you to resolve issues; clear communication helps us support you better.</p>
    </div>
  );
};

export default LegalRefund;
